import styled, { keyframes } from 'styled-components';

const popIn = keyframes`
    0% {
        transform: scale(0);
    }
    50% {
        transform: scale(1.2);
    }
    100% {
        transform: scale(1);
    }
`;

const confettiAnimation = keyframes`
    0% {
        transform: translateY(0) scale(1);
        opacity: 1;
    }
    100% {
        transform: translateY(-20px) scale(0.8);
        opacity: 0;
    }
`;

export const ReactionIconWrapper = styled.div`
    position: absolute;
    top: 12px;
    left: 12px;
    z-index: 2;
    pointer-events: none;
`;

export const ReactionEmoji = styled.span`
    font-size: 32px;
    line-height: 1;
    display: block;
    animation: ${popIn} 0.3s ease-out;
    filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.3));
`;

export const ConfettiParticle = styled.span`
    position: absolute;
    font-size: 16px;
    top: 0;
    animation: ${confettiAnimation} 1s ease-out forwards;
    pointer-events: none;
`;
